module.exports = __webpack_public_path__ + "img/photo-0115.533381e2.jpg";